import React from 'react';
import classnames from 'classnames';

export default props => (
  <button
    className={classnames('btn', { active: props.isActive })}
    onClick={props.onClick}
  >
    {props.label}
  </button>
);
